import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Big from "big.js";
import { debounce } from "util";
import { FormattedNumber } from "react-intl";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import {
  Page,
  DataTable,
  StyledButton,
  CurrencyField,
  TextField,
  IconButton,
  Loadable
} from "components/support";

import Filter from "../filter";
import Operation from "./operation";
import { UnitLabels } from "core/enum";
class InventoryModifyView extends Component {
  tableConfiguration = () => {
    const { viewModel } = this.props;

    return {
      identifier: "uuid",
      columns: [
        {
          accessor: "uuid",
          show: false
        },
        {
          accessor: "category_uuid",
          show: false
        },
        {
          id: "code",
          accessor: "code",
          Header: "Código",
          align: "center"
        },
        {
          id: "name",
          accessor: "name",
          Header: "Nome"
        },
        {
          id: "stock_count",
          accessor: "stock_count",
          Header: "Total Estoque",
          align: "right"
        },
        {
          id: "sum_stock_value",
          accessor: "sum_stock_value",
          Header: "Valor de Estoque",
          align: "right",
          Cell: props => this.parseMoneyField(props.original.getStockValue())
        },
        {
          id: "quantity",
          Header: "Quantidade",
          align: "center",
          sortable: false,
          Cell: props => this.parseQuantityField(props.original)
        },
        {
          id: "cost_value",
          Header: "Valor de Compra",
          align: "center",
          sortable: false,
          show: viewModel.operationType === "in",
          Cell: props => this.parseCostValueField(props.original)
        }
      ]
    };
  };

  parseMoneyField = value => (
    <FormattedNumber value={Big(value).div(100)} format="BRL" />
  );

  parseQuantityField = product => (
    <TextField
      fullWidth
      value={
        (this.props.viewModel.modifications[product.uuid] || {}).quantity || ""
      }
      onChange={(_, value) =>
        this.props.presenter.onChangeField(
          "quantity",
          product.uuid,
          value,
          UnitLabels[product.unit_label].fractional
        )
      }
    />
  );

  getCostValue = uuid => {
    const currentCostValue =
      (this.props.viewModel.modifications[uuid] || {}).costValue || "";

    if (currentCostValue) {
      return Big(currentCostValue)
        .div(100)
        .toFixed(2);
    } else {
      return "0.00";
    }
  };

  parseCostValueField = product => (
    <CurrencyField
      fullWidth
      value={this.getCostValue(product.uuid)}
      unit="R$ "
      onChange={(_, value) =>
        this.props.presenter.onChangeField("costValue", product.uuid, value)
      }
    />
  );

  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      nextProps.presenter.onFilterChange(nextProps.filter);
    }
  }

  render() {
    const { presenter, viewModel } = this.props;
    const {
      loading,
      resultSet,
      pagination,
      order,
      errors,
      operationType,
      note
    } = viewModel;
    const config = this.tableConfiguration();

    return (
      <Page>
        <Row>
          <Col xs={12}>
            <Typography type="display1" className="pb-sm">
              <Row>
                <Col xs>
                  <IconButton
                    icon="arrow_back"
                    onClick={() => presenter.onGoBack()}
                  />
                  <span>Modificar Estoque</span>
                </Col>
                <Col>
                  <StyledButton
                    accent
                    style={{ marginRight: 0 }}
                    label="Entrada por XML"
                    onTouchTap={() => presenter.onRequestModifyByXML()}
                  />
                </Col>
              </Row>
            </Typography>
          </Col>
          <Col className="product__content" xs={12}>
            <Filter
              onFilter={debounce(filtered =>
                presenter.onFilterChange(filtered)
              )}
              loading={loading}
            />
          </Col>
          <Col className="product__content" xs={12}>
            <Operation
              operationType={operationType}
              note={note}
              onChangeOperation={(field, value) =>
                presenter.onChangeOperation(field, value)
              }
              errors={errors}
              loading={loading}
            />
          </Col>
          <Col lg={12} xs={12}>
            <div>
              <h3 style={{ textAlign: "right", padding: 10, margin: 0 }}>
                {pagination.total} produtos(s) encontrado(s).
              </h3>
              <Paper elevation={1} className="product__content">
                <Loadable loading={loading}>
                  <DataTable
                    manual
                    resultSet={resultSet}
                    total={pagination.total}
                    perPage={pagination.perPage}
                    page={pagination.currentPage}
                    config={config}
                    onChange={({ field, value }) =>
                      presenter.onOrderChange(field, value)
                    }
                    orderField={order.field}
                    orderDirection={order.direction}
                    onPageChange={page => presenter.onPageChange(page + 1)}
                  />
                </Loadable>
              </Paper>

              <div
                className="text-right p-sm"
                style={{
                  textAlign: "right",
                  padding: "10px 0 10px 10px",
                  margin: 0
                }}
              >
                <StyledButton
                  label="Cancelar"
                  onClick={() => presenter.onGoBack()}
                />
                <StyledButton
                  primary
                  label="Modificar Estoque"
                  style={{ marginRight: 0 }}
                  onClick={() => presenter.onStockModify()}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Page>
    );
  }
}

export default InventoryModifyView;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/modify/view.jsx